import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 获取当前月份
import { setAttendanceCycle, getAttendanceCycle } from 'api/Attendance/monthly-statistics';
var month = new Date().getMonth() + 1;
// 上月
var lastMonth = month - 1 < 1 ? 12 : month - 1;
// 获取当月的最后一天
var getLastDate = function getLastDate(month) {
  var year = new Date().getFullYear();
  if (month < lastMonth) year -= 1;
  return new Date(year, month, 0).getDate();
};
// 可选月份 固定为上月与本月
var selectDate = function selectDate($t) {
  return [{
    label: $t('last_mouth'),
    value: lastMonth
  }, {
    label: $t('1950'),
    value: month
  }];
};
export default {
  props: {
    // 1 新增（新增时如果已经存在则提示刷新） 2 更新
    type: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      visible: false,
      // 可选月份 固定为上月与本月
      selectDate: selectDate(this.$t),
      form: {
        month_at: month,
        // 可选月份
        month_date: 1 // 选择日期
      },

      confirmRisks: false,
      // 风险确认
      subLoad: false // 提交loading
    };
  },

  computed: {
    // 天数选项
    optionalDate: function optionalDate(vm) {
      // 最大可选日期
      // 所选月份最后一天
      var maxDate = getLastDate(vm.form.month_at);
      // 最小可选日期
      // 开始日期可选范围为上月2日至当月31日，
      var minDate = vm.form.month_at === month ? 1 : 2;
      return Array.from({
        length: maxDate
      }, function (_, index) {
        return index + 1;
      }).filter(function (item) {
        return item >= minDate;
      });
    },
    // 1. 开始日期为上月x日时，则结束日期为当月x-1日
    // 2. 开始日期为当月y日时，则结束日期为次月y-1日
    // 3. 特殊的，当开始日期为当月1日时，结束日期为本月底
    endDate: function endDate(vm) {
      var _vm$form = vm.form,
        month_at = _vm$form.month_at,
        month_date = _vm$form.month_date;
      if (month_at === month && month_date === 1) return vm.$t('1951');
      // `次月${month_date - 1}日`
      if (month_at === month) return vm.$t('1952', {
        x: month_date - 1
      });
      // `当月${month_date - 1}日`
      return vm.$t('1953', {
        x: month_date - 1
      });
    },
    // 标题 区分编辑和修改
    titleDetail: function titleDetail(vm) {
      return vm.type === 1 ? vm.$t('1954') : vm.$t('71');
    },
    // 考勤展示文案 例：本月10号到下月10号
    attendanceText: function attendanceText(vm) {
      var _vm$form2 = vm.form,
        month_at = _vm$form2.month_at,
        month_date = _vm$form2.month_date;
      if (month_at === month && month_date === 1) return vm.$t('attend_month2');
      if (month_at === month) return vm.$t('attend_month3', {
        x: month_date,
        y: month_date - 1
      });
      return vm.$t('attend_month1', {
        x: month_date,
        y: month_date - 1
      });
    }
  },
  mounted: function mounted() {
    var _this = this;
    if (this.type === 2) {
      getAttendanceCycle().then(function (res) {
        // 可选日期转换 // 1 上月 2 本月
        _this.form = res.data;
        _this.form.month_at = res.data.month_at === 2 ? month : lastMonth;
        _this.handlerUpdate();
      });
    }
  },
  methods: {
    goback: function goback() {
      this.$router.go(-1);
    },
    // 更新父元素文案
    handlerUpdate: function handlerUpdate() {
      var _this2 = this;
      this.$nextTick(function () {
        _this2.$emit('updateText', _this2.attendanceText);
      });
    },
    // 提交
    doSubmit: function doSubmit() {
      var _this3 = this;
      this.subLoad = true;
      // 可选日期转换 // 1 上月 2 本月
      var params = _objectSpread(_objectSpread({}, this.form), {}, {
        set_type: this.type,
        month_at: this.form.month_at === month ? 2 : 1
      });
      setAttendanceCycle(params).then(function (res) {
        //  关闭弹窗 数据更新
        _this3.handlerCancel();
        _this3.handlerUpdate();
        if (params.set_type === 1) _this3.$emit('init');
      }).finally(function () {
        return _this3.subLoad = false;
      });
    },
    // 关闭弹窗
    handlerCancel: function handlerCancel() {
      this.visible = false;
    }
  }
};